/**
 * Alpha blend mode.
 */
export enum BlendMode {
  /** SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */
  Normal,
  /** SRC ALPHA * SRC + ONE * DEST */
  Additive
}
